import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Skeleton } from '@mui/material';
export const Icon = ({ isLoading, skeletonSx, icon }) => {
    if (isLoading) {
        return (_jsx(Skeleton, { variant: "circular", height: "1.5rem", width: "1.5rem", sx: skeletonSx }));
    }
    return _jsx(_Fragment, { children: icon });
};
